import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const thisBottomSpacing = rem(32);
    return css`
      padding-bottom: ${thisBottomSpacing};
      margin-bottom: ${thisBottomSpacing};
      border-bottom: ${rem(1)} solid ${theme.colors.neutral.gray};
    `;
  }
}`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    return css`
      ::after {
        content: '';
        display: block;
        width: ${rem(60)};
        padding-bottom: ${rem(16)};
        margin: 0 auto;
        border-bottom: ${rem(4)} solid ${theme.colors.gold.gold};
      }
    `;
  }}
`;
